import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { TextField, Grid, Card, Typography, CardContent, Button, Tooltip, FormControlLabel, Checkbox } from '@mui/material';
import { updateUser } from '../redux/ActionCreator';
import InfoIcon from '@mui/icons-material/Info';
import CreatableSelect from 'react-select/creatable';
import config from '../config.json';
import { fetchAttributeValues, KeyFillDropDown } from "../functions/helpers/general";
import { handleFormChange } from '../functions/multiDropDown';
import { apiRequest } from '../functions/apiRequest';
import { uploadImageToR2 } from '../functions/r2BulkUpload';
const skills = [{
	value: 'Coding', label: 'Coding 1',
}, {
	value: 'Coding 1', label: 'Coding 2',
}, {
	value: 'Coding 2', label: 'Coding 3',
}, {
	value: 'Coding 3', label: 'Coding 4',
}, {
	value: 'Coding 4', label: 'Coding 5',
},]

const token = localStorage.getItem('token')
const userID = localStorage.getItem('userID')

export default function ProfileUpdatePage() {

	const initialFormData = Object.freeze({
		about: '',
		first_name: '',
		last_name: '',
		mobile_number: '',
		secondary_email_id: '',
		linkedin_url: '',
		is_hl_active: true,
	});

	const [formData, updateFormData] = useState(initialFormData);
	const dispatch = useDispatch()

	const [image, setImage] = useState(null)
	const [options, setOptions] = useState(skills);
	const [selectedOpts, setSelectedOpts] = useState();
	const [user, setUser] = useState({});
	const [colleges, setColleges] = useState([]);
	const [communities, setCommunities] = useState([]);
	const [schools, setSchools] = useState([]);
	const [organisations, setOrganisations] = useState([]);

	useEffect(() => {
		async function getSkills() {
			const response = await fetch(process.env.REACT_APP_API_URL + `/api/skills/all`, {
				method: 'GET',
				headers: {
					"Content-Type": 'application/json',
					"Authorization": `Token ${token}`
				},

			})
			const json = await response.json();
			setOptions(json.response.response_data);
		}
		async function getUserData() {
			const response = await fetch(process.env.REACT_APP_API_URL + `/api/skills/${userID}`, {
				method: 'GET',
				headers: {
					"Content-Type": 'application/json',
					"Authorization": `Token ${token}`
				},

			})
			const json = await response.json();
			const userInfo = await apiRequest('get', null, `/user/profile/${userID}`, token, null, {}, true);
			setUser({ ...userInfo.data });
			updateFormData({ ...userInfo.data });
			setSelectedOpts(json.response.response_data);
		}
		getUserData();
		fetchAttributeValues({ setCommunities, setSchools, setColleges, setOrganisations, model: 'user' });
		getSkills();
		// eslint-disable-next-line
	}, [])

	const handleImageChange = (e) => {
		setImage(e.target.files[0])
	};

	const handleSubmit = () => {
		//console.log(formData)

		const body = {
			first_name: formData.first_name ? formData.first_name : user['first_name'],
			last_name: formData.last_name ? formData.last_name : user['last_name'],
			mobile_number: formData.mobile_number ? formData.mobile_number : user['mobile_number'],
			about: formData.about ? formData.about : user['about'],
			secondary_email_id: formData.secondary_email_id ? formData.secondary_email_id : user['secondary_email_id'],
			linkedin_url: formData.linkedin_url ? formData.linkedin_url : user['linkedin_url'],
			skills: selectedOpts,
			community: formData.community ? formData.community : user['community'],
			school: formData.school ? formData.school : user['school'],
			college: formData.college ? formData.college : user['college'],
			org_name: formData.org_name ? formData.org_name : user['org_name'],
			is_hl_active: formData.is_hl_active
		}

		dispatch(updateUser(token, userID, body))

		if (image && typeof image !== 'string') {
			uploadImageToR2(image, 'profile')
				.then((url) => {
					if (url) {
						fetch(`${process.env.REACT_APP_API_URL}/api/user/pic/${userID}`, {
							method: 'PUT',
							headers: {
								'Content-type': 'application/json',
								'Authorization': `Token ${token}`
							},
							body: JSON.stringify({
								'profile_pic': url
							})
						}).catch(err => console.error(err));
					}
				})
				.catch(err => console.error('Failed to upload profile picture to R2:', err));
		}
	}

	const handleChange = (e) => {
		updateFormData({
			...formData,
			// Trimming any whitespace
			[e.target.name]: e.target.value.trim(),
		});

	}

	const handleCheckBox = (e) => {
		updateFormData({
			...formData,
			"is_hl_active": e.target.checked
		})
	}

	return (
		<Grid container style={{ justifyContent: 'center', display: 'flex' }}>
			<Grid item xs={12}>
				<h1 style={{ fontSize: 40, fontFamily: 'Raleway', textAlign: 'center' }}>Edit Profile</h1>
			</Grid>
			<Grid item xs={12} md={8} >
				<Card variant='outlined' style={{ marginTop: 20 }}>
					<CardContent style={{}}>
						<Grid container spacing={3} >
							<Grid item xs={6} md={4}>
								<Typography>First Name</Typography>
								<TextField variant='outlined' fullWidth name='first_name' placeholder={user['first_name']} onChange={handleChange}> </TextField>
							</Grid>
							<Grid item xs={6} md={4}>
								<Typography>Last Name</Typography>
								<TextField name='last_name' fullWidth variant='outlined' placeholder={user['last_name']} onChange={handleChange}> </TextField>
							</Grid>
							<Grid item xs={6} md={4}>
								<Typography>Mobile Number</Typography>
								<TextField name='mobile_number' fullWidth variant='outlined' placeholder={user['mobile_number']} onChange={handleChange}> </TextField>
							</Grid>
							<Grid item xs={6} md={4}>
								<Typography>Secondary Email ID</Typography>
								<TextField name='secondary_email_id' fullWidth onChange={handleChange} placeholder={user['secondary_email_id']} defaultValue='' variant='outlined' style={{ fontSize: 100 }} />
							</Grid>
							<Grid item xs={6} md={4}>
								<Typography>LinkedIn Profile URL</Typography>
								<TextField name='linkedin_url' fullWidth onChange={handleChange} placeholder={user['linkedin_url']} defaultValue='' variant='outlined' style={{ fontSize: 100 }} />
							</Grid>
							<Grid item xs={6} md={4}>
								<Typography>Community</Typography>
								<KeyFillDropDown
									size="medium"
									options={communities}
									keyName="community"
									formData={formData}
									updateFormData={updateFormData}
									handleFormChange={handleFormChange}
									placeholder="Enter or Select your community" 
								/>
							</Grid>
							<Grid item xs={6} md={4}>
								<Typography>School</Typography>
								<KeyFillDropDown
									size="medium"
									options={schools}
									keyName="school"
									formData={formData}
									updateFormData={updateFormData}
									handleFormChange={handleFormChange}
								/>
							</Grid>
							<Grid item xs={6} md={4}>
								<Typography>College</Typography>
								<KeyFillDropDown
									size="medium"
									options={colleges}
									keyName="college"
									formData={formData}
									updateFormData={updateFormData}
									handleFormChange={handleFormChange}
								/>
							</Grid>
							<Grid item xs={6} md={4}>
								<Typography>Organisation</Typography>
								<KeyFillDropDown
									size="medium"
									options={organisations}
									keyName="org_name"
									formData={formData}
									updateFormData={updateFormData}
									handleFormChange={handleFormChange}
								/>
							</Grid>
							<Grid item md={12} xs={12}>
								<Typography >
									Skills
									<Tooltip
										style={{ fontSize: 30 }}
										title="Select Skills"
										arrow
									>
										<InfoIcon style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor, paddingLeft: '2px' }} />
									</Tooltip>
								</Typography>
								{selectedOpts &&
									<CreatableSelect
										defaultValue={selectedOpts}
										isMulti
										onChange={(newValue) => setSelectedOpts(newValue)}
										options={options}
										maxMenuHeight='20vh'
									/>
								}

							</Grid>

							<Grid item xs={12}>
								<Typography>About me: </Typography>
								<TextField name='about' multiline placeholder={user['about']} variant='outlined' fullWidth onChange={handleChange}> </TextField>
							</Grid>
							<Grid item xs={12}>
								<FormControlLabel
									control={
										<Checkbox
											checked={formData.is_hl_active}
											onChange={handleCheckBox}
											style={{ color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor }}
										/>
									}
									label="Display my profile on the Human Library" value="is_hl_active"
								/>
							</Grid>
							<Grid item xs={12}>
								<Typography>Upload Profile Picture</Typography>
								<input
									type="file" id="image" accept="image/png, image/jpeg, image/jpg" multiple
									onChange={handleImageChange}
								/>
							</Grid>

							<Grid item xs={12}>
								<Button onClick={handleSubmit} style={{ backgroundColor: '#3c1361', color: '#ffffff', textTransform: 'None', fontFamily: 'Raleway' }}>Submit Changes</Button>
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</Grid>
		</Grid>





	)


}


